
import tools from "@/common/tool"
import urls from "@/common/urls"
import axios from "@/common/axios"
import store from "@/store"
export const commonRouterBefore = (to, from, next) => {
    next()
}
export const adminRouterBefore = (to, from, next) => {
    if (store.state.common.userInfo?.id) {
        next()
    } else {
        let data = tools.getStorage("user-login-data", localStorage) || {};
        if (data.phone && data.code) {
            axios.post(urls.user.login, data, {}, false).then(res => {
                tools.setStorage("user-login-data", res.data, sessionStorage);
                store.dispatch("setItem", { userInfo: res.data })
                next()
            }).catch(() => {
                next('/login')
            })
            return;
        }
        next('/login')
    }
}
export const reportAdminRouterBefore = (to, from, next) => {
    if (store.state.common.userInfo?.id) {
        next()
    } else {
        let data = tools.getStorage("report-login-data", localStorage) || {};
        if (data.phone && data.code) {
            axios.post(urls.user.login, data, {}, false).then(res => {
                tools.setStorage("user-login-data", res.data, sessionStorage);
                store.dispatch("setItem", { userInfo: res.data })
                next()
            }).catch(() => {
                next('/login')
            })
            return;
        }
        next('/login')
    }
}
export const liveRouterBefore = async (to, from, next) => {
    let signInfo = store.state.common.signInfo ? store.state.common.signInfo[to.query.id] : {};
    //有type参数表示是飞检链接
    if (to.query.type) {
        let url = tools.getURL(urls.live.sign_info, { id: to.query.id, device_code: encodeURI(tools.getStorage("device-code", localStorage) || "") })
        let response = await axios.get(url)
        // 直播结束 弹提示 直播已结束，感谢观看
        if (response.data.tx_meet_status == 20) {
            next({
                path: `/endLive`
            })
        }
        // query.type == 1为飞检链接，其他为内部链接,inspection_switch为1表示该场会被飞检，反正不是
        if (to.query.type == 1 && response.data.inspection_switch != 1) {
            next({
                path: `/endLive`,
                query: {
                    isFlyCheckUrl: 1
                }
            })
        }
        next()
        return;
    }
    // if (to.query.sign) {
    //   next()
    //   return;
    // }
    if (to.query.sign && signInfo.openid) {
        if (to.name == "live") next()
        else next({
            path: `/live`,
            query: to.query
        })
        return;
    }
    // if(to.name == 'sign'){
    //   next();
    //   return;
    // }
    let url = tools.getURL(urls.live.sign_info, { id: to.query.id, device_code: encodeURI(tools.getStorage("device-code", localStorage) || "") })
    let response = await axios.get(url)
    // 直播结束 弹提示 直播已结束，感谢观看
    if (response.data.tx_meet_status == 20) {
        next({
            path: `/endLive`
        })
    }
    if (to.query.sign && response.data.status == 1) {
        signInfo[to.query.id] = response.data
        store.dispatch("setItem", { signInfo })
        tools.setStorage("device-code", response.data.device_code, localStorage)
        next({
            path: `/live`,
            query: to.query
        })
    } else {
        if (to.name == 'sign') next();
        else next({
            path: `/sign`,
            query: { id: to.query.id }
        })
    }
}